import React from 'react';

export default function SalesDatePickerPage(props) {
  // TODO: Add Date picker bread crumb
  return <>{props.children}</>;
}
